import { render, staticRenderFns } from "./newFisherman.vue?vue&type=template&id=16b5ace6&"
import script from "./newFisherman.vue?vue&type=script&lang=js&"
export * from "./newFisherman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports